import { Layout } from '../layout'
import { Helmet } from 'react-helmet-async'
import { ExpeditionsPage } from '../components/ExpeditionsPage'
import content from '../data/content.json'

export default function Expeditions() {
  const downloadLink = content.downloads.sections.find(s => s.title === 'Expedition')?.items?.[0]?.link; 

  return (
    <Layout theme='dark' pageClass='infopage-wrapper'>
      <Helmet>
        <title> Expeditions | Cuttlebase </title>
      </Helmet>
          <ExpeditionsPage content={content.expeditions} downloadLink={downloadLink} />
    </Layout>
  )
}